<script lang="ts">
  import {Button} from '@components';
  import {toTime} from '@/utils/common';
  import {createEventDispatcher} from 'svelte';
  import ProgressBar from './ProgressBar.svelte';
  import editorStore from '../../lib/editor/editor.store';
  import {animationPlayerStore} from '../animations/AnimationController.svelte';
  import {fly} from 'svelte/transition';
  import {step} from '../../store';
  import {STEP} from '../../types/common';

  export let progressBar: any;
  export let showDuration: boolean = false;
  export let duration: number = 0;
  export let progress: number = 0;
  const dispatch = createEventDispatcher();

  const stopVideo = () => dispatch('stop-video');
  const playVideo = () => dispatch('play-video');
  const pauseVideo = () => dispatch('pause-video');
  const seekTimeline = (e: CustomEvent) => dispatch('seek-timeline', e.detail);
  const clearEditorStore = () => {
    if (!$editorStore.active) return false;
    // editorStore.highlightElement(null);
    editorStore.setActiveComponent(null);
  };

  $: playable = !$animationPlayerStore.loading;
  $: btnClass = !playable ? 'bg-gray-500 cursor-wait border-gray-500' : 'bg-primary border-primary';
</script>

<div class="relative">
  {#if $step === STEP.PREVIEW}
    {#if !playable}<div
        in:fly={{x: -100, duration: 100}}
        out:fly={{x: -100, duration: 100}}
        class="absolute flex items-center justify-center gap-2 rounded-tr-md bg-gray-100 px-4 py-2 font-bold"
        id="progressBar"
      >
        <i class="fa fa-spinner block animate-spin"></i> <span class="block">Loading...</span>
      </div>{/if}
  {/if}
  <div class="z-20 flex w-full items-center gap-3 border-t border-zinc-300 bg-white p-4">
    <Button
      disabled={!playable}
      on:click={stopVideo}
      icon="Stop"
      iconSize="small"
      className="!rounded-full !text-white  border-4  !py-2 {btnClass}"
    />
    <Button
      disabled={!playable}
      on:click={playVideo}
      icon="Play"
      iconSize="small"
      className="!rounded-full !text-white border-4  !py-2 {btnClass}"
    />
    <Button
      disabled={!playable}
      on:click={pauseVideo}
      icon="Pause"
      iconSize="small"
      className="!rounded-full !text-white  border-4  !py-2 {btnClass}"
    />
    {#if playable}
      <ProgressBar bind:this={progressBar} on:progress-change={seekTimeline} />
      {#if showDuration}
        {#if duration > 0}
          <div class="flex font-medium text-zinc-900">
            <span>{toTime(duration * (progress / 100))} / {toTime(duration)}</span>
          </div>
        {:else}
          <div class="flex font-medium text-zinc-700">--:-- / --:--</div>
        {/if}
      {/if}
    {/if}
  </div>
</div>

<style>
  #progressBar {
    height: 30px;
    top: -29px;
    min-width: 90px;
    display: flex;
    font-size: 7pt;
  }
</style>
